import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { clientsService } from '../api/clients.service';
import { CLIENTS_KEYS } from './queryKeys';
import type { UpdateClientPayload } from '../types';

export function useUpdateClient() {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: ({ clientId, payload }: { clientId: string; payload: UpdateClientPayload }) =>
      clientsService.update(clientId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CLIENTS_KEYS.byOrg(activeOrganizationId!) });
    },
  });
}
